import type { LogoutType } from '@pt/enums/logs'
import { ptLogs } from '@com/utils/report-logs/pt'

export interface LogoutLogOption {
  type: LogoutType
  msg: string
}

export function sendLogoutLog(option: LogoutLogOption): void {
  const action = ptLogs.createAction({ scene: 'logout' })

  action.log({
    e: String(option.type),
    extra: {
      msg: option.msg,
    },
  })
  // console.error(JSON.stringify(option))
}
